import guid from './guid';
import isSessionStorageAvailable from './isSessionStorageAvailable';

function getSessionId() {
    var curSessionId, sessionIdKey = 'alan_session_id';
    const hasStorage = isSessionStorageAvailable();

    curSessionId = hasStorage ? sessionStorage.getItem(sessionIdKey) : window.sessionId;

    if (!curSessionId) {
        curSessionId = guid();
        if (hasStorage) {
            sessionStorage.setItem(sessionIdKey, curSessionId);
        } else {
            window.sessionId = curSessionId;
        }
    }
    return curSessionId;

}

export default getSessionId;
